import apiClient from "./axiosConfig";

export const getInvoiceResourceGeneration = async (request) =>
    apiClient.feesAPI.post(`/api/getInvoiceResourceGeneration`, request);

export const createInvoice = async (request) =>
    apiClient.feesAPI.post(`/api/postInvoiceGeneration`, request);

export const createCreditNote = async (request) =>
    apiClient.feesAPI.post(`/api/createCreditNote`, request);
